import React from 'react';
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
} from 'react-router-dom';
import { Tab } from '../../components/Tab';
import { ExchangeAllOrderPage } from './exchange/ExchangeAllOrderPage';
import { ExchangeBooksOrderPage } from './exchange/ExchangeBooksOrderPage';
import { ExchangeProductsOrderPage } from './exchange/ExchangeProductsOrderPage';

export const ExchangeOrderMain = () => {
  const { pathname } = useLocation();
  const { push } = useHistory();
  return (
    <>
      <div className="flex space-x-4 border-b">
        <Tab
          text="전체"
          selected={pathname === '/admin/exchange/order/all'}
          onClick={() => push('/admin/exchange/order/all')}
        />
        <Tab
          text="도서"
          selected={pathname === '/admin/exchange/order/books'}
          onClick={() => push('/admin/exchange/order/books')}
        />
        <Tab
          text="일반상품"
          selected={pathname === '/admin/exchange/order/products'}
          onClick={() => push('/admin/exchange/order/products')}
        />
      </div>
      <Switch>
        <Route
          component={ExchangeAllOrderPage}
          path="/admin/exchange/order/all"
        />
        <Route
          component={ExchangeProductsOrderPage}
          path="/admin/exchange/order/products"
        />
        <Route
          component={ExchangeBooksOrderPage}
          path="/admin/exchange/order/books"
        />
        <Route path="/admin/exchange/order">
          <Redirect to="/admin/exchange/order/all" />
        </Route>
      </Switch>
    </>
  );
};
